import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiTrendingUp, FiFilter, FiShield, FiGlobe, FiFileText, FiBell } = FiIcons;

const BenefitsSection = () => {
  const benefits = [
    {
      icon: FiClock,
      title: "זמינות רציפה תחת המותג",
      text: "כל פנייה נענית מיידית, גם בלילה ובחג, בטון מקצועי עקבי."
    },
    {
      icon: FiTrendingUp,
      title: "30% ↑ ערך לידים",
      text: "טפסי דיאלוג דינמיים שואלים את המידע המהותי בשפה אנושית ומקטינים נטישה."
    },
    {
      icon: FiFilter,
      title: "סינון ענייני ומיון משפטי",
      text: "תחום, סמכות שיפוט, דחיפות, שווי/הערכת נזק, מסמכים חיוניים – מסודר לפי דיאלוג ותפריט הסוכן."
    },
    {
      icon: FiShield,
      title: "שליטה משפטית מלאה",
      text: "מאגר תשובות מאושר על פי אתר המותג, דיסקליימרים ומדיניות תגובה לפי כללי אתיקה."
    },
    {
      icon: FiGlobe,
      title: "רב-לשוניות אמיתית",
      text: "עברית/ערבית/רוסית/אנגלית ועוד 100+, מגדיל היקף פניות איכותיות."
    },
    {
      icon: FiFileText,
      title: "תיעוד ואודיטביליות",
      text: "כל אינטראקציה נשמרת עם חותמת זמן, יצוא ל-CRM (HubSpot, Salesforce, Monday), יישור קו לנהלי המשרד."
    },
    {
      icon: FiBell,
      title: "התראות 'לקוח חם'",
      text: "בקשת שיחה/דחיפות/קייס בעל ערך → התראה מיידית לנציג ומעבר לנציג בלייב."
    }
  ];

  return (
    <section className="benefits-section section bg-gray-50">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            למה זה חובה למשרד משפטי
          </h2>
        </motion.div>
        
        <div className="benefits-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              className="benefit-card bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <div className="icon-wrapper mb-6">
                <SafeIcon 
                  icon={benefit.icon} 
                  className="text-4xl text-primary-600"
                  style={{ color: '#8976FD' }}
                />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;